(function ($) {
    $(document).ready(function () {
        validateForm();
        blockInvalidChars('#phone');
        // handleSuccess();
    });
    const $form = $('form.contact-form');
    function validateForm() {
        $form.validate({
            rules: {
                'contact[name]': { required: true },
                'contact[phone]': { required: true, digits: true },
                'contact[email]': { required: true, email: true },
                'contact[mail_confirm]': {
                    required: true,
                    email: true,
                    equalTo: '#mail',
                },
                'contact[body]': { required: true },
                'contact[policy]': { required: true },
            },
            errorPlacement: function (error, element) {
                // error.insertAfter(element);
            },
            highlight: function (element) {
                // $(element).addClass('has-error');
            },
            unhighlight: function (element) {
                // $(element).removeClass('has-error');
            },

            invalidHandler: function () {
                $('html, body').animate(
                    { scrollTop: $('#content').offset().top },
                    100
                );
            },
        });
    }
    $('.btn_contact').on('click', function (e) {
        if (!$form.valid()) {
            e.preventDefault();
            $('.error').css('display', 'block');
            return false;
        }
    });
    $form.find('input, textarea').on('input', function () {
        $('.error').css('display', 'none');
    });
    // Block invalid characters for number input
    function blockInvalidChars(selector) {
        const invalid = ['-', '+', 'e', 'E'];
        $(document).on('input', selector, function () {
            this.value = this.value.replace(/[^\d]/g, ''); // remove all non-digits
        });
        $(document).on('keydown', selector, function (e) {
            if (invalid.includes(e.key)) e.preventDefault();
        });
    }

    function handleSuccess() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('contact_posted') === 'true') {
            $('#content').hide();
            $('#success').show();
        }

    }
})(jQuery);
